import React from "react";
import { TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { observer } from "mobx-react";
import Lottie from "lottie-react";

import Colors from "../../Resources/Color";
import LoadingBoldWhite from "../../assets/LoadingBoldWhite.json";
import LoadingBold from "../../assets/LoadingBold.json";
import NetworkManager from "../Classes/NetworkManager";
import { SyncDomainStatus } from "../sync/SyncDomainController";

const SyncDomainIndicator = observer(function SyncDomainIndicator({
  syncController,
  white = false,
  onPress,
}) {
  const networkManager = NetworkManager.getInstance();
  const status = syncController?.status ?? SyncDomainStatus.OK;

  const handlePress = async () => {
    if (typeof onPress === "function") {
      await onPress();
      return;
    }

    if (!syncController) {
      return;
    }

    syncController.retryFailed();
    syncController.flush();
  };

  const renderIcon = () => {
    if (networkManager.isOffline && status !== SyncDomainStatus.ERROR) {
      return <Ionicons name="cloud-offline-outline" size={20} color={Colors.grayColor} />;
    }

    switch (status) {
      case SyncDomainStatus.SYNCING:
        return (
          <Lottie
            animationData={white ? LoadingBoldWhite : LoadingBold}
            loop
            style={{ maxWidth: 18 }}
          />
        );

      case SyncDomainStatus.ERROR:
        return <Ionicons name="alert-circle-outline" size={20} color={Colors.redColor || "red"} />;

      case SyncDomainStatus.ATTENTION:
        return <Ionicons name="alert-circle-outline" size={20} color={Colors.orangeColor || "#d97706"} />;

      case SyncDomainStatus.OFFLINE_PENDING:
        return <Ionicons name="cloud-offline-outline" size={20} color={Colors.orangeColor || "#d97706"} />;

      case SyncDomainStatus.OK:
      default:
        return (
          <Ionicons
            name="cloud-done-outline"
            size={20}
            color={white ? Colors.whiteColor : Colors.blackColor}
          />
        );
    }
  };

  return (
    <TouchableOpacity activeOpacity={0.8} onPress={handlePress}>
      <View>{renderIcon()}</View>
    </TouchableOpacity>
  );
});

export default SyncDomainIndicator;
